import { Component, OnInit } from '@angular/core';
import { ClinicSetupService } from '../clinic-setup.service';
import {
  emailNotificationTypeToFriendlyNameMap,
  emailNotificationTypeToInfoPopoverMap
} from './email-notification-recipients.model';

@Component({
  selector: 'csi-email-notification-recipients-setup',
  templateUrl: './email-notification-recipients-setup.component.html',
  styleUrls: ['./email-notification-recipients-setup.component.css']
})
export class EmailNotificationRecipientsSetupComponent implements OnInit {
  public emailNotificationTypeToFriendlyNameMap = emailNotificationTypeToFriendlyNameMap;
  public emailNotificationTypeToInfoPopoverMap = emailNotificationTypeToInfoPopoverMap;
  constructor(public clinicSetupService: ClinicSetupService) {}

  ngOnInit() {}
}
